<template>
    <div class="main-content clearfix">
        <div class="container">
            <div class="card p-4">
                <div class="cart-section">
                    <h3 class="mb-3">Your Cart</h3>
                    <div class="row">
                        <div class="col-md-12 col-lg-8"  v-if="projectCart && projectCart.Project_tans.length">
                            <div
                                class="card product-cart-card mb-4"
                                v-for="items in projectCart.Project_tans"
                                :key="items.id"

                            >
                                <div class="card-body">
                                    <div class="product-h-item">
                                        <div class="product-h-item-img d-flex justify-content-center">
                                            <router-link :to="`/product/${str_encode(items.product_sizes_id)}`"> 
                                            <div
                                                v-lazy-container="{
                                                    selector: 'img'
                                                }"
                                            >
                                                <img
                                                    :data-src="
                                                        set_image(items.photo)
                                                    "
                                                    class="card-img-top pro-img"
                                                    :alt="items.name"
                                                    data-error="assets/images/no_image.svg"
                                                    data-loading="assets/images/loading.gif"
                                                />
                                            </div>
                                            </router-link>
                                        </div>
                                        <div class="product-h-item-info">
                                            <div class="">
                                                <div class="row product-spec">
                                                    <div class="col-md-9">
                                                        <p class="mb-1">
                                                            <router-link :to="`/product/${str_encode(items.product_sizes_id)}`" class="title"> <span v-html="items.name"></span> </router-link>
                                                        </p>
                                                        <p class="mb-0 font-14" v-if="items.box_sqft">Total Sqft: {{ parseFloat(items.box_sqft * items.qty).toFixed(2) }}</p>

                                                        <div class="spec-left mt-1">
                                                            <p class="font-14 mb-1" ><b>SKU: </b >{{ items.sku }}</p>
                                                            <span class="font-10"></span>
                                                            
                                                            <h6 class="mb-0 text-purple delivery-day" v-if="showroomId && showroomId.basic_addon"> <span style="display: inline-block; transform: rotateY('180deg');"><i class="fa fa-truck " aria-hidden="true"></i></span> <span >FREE Shipping / Pickup</span> </h6>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 ">
                                                        <div class="text-end">
                                                            <h5 class="mb-1">
                                                                {{
                                                                    items.product_total_price
                                                                        | toCurrency
                                                                }}
                                                            </h5>
                                                        </div>

                                                        <div class="d-flex justify-content-end">
                                                            <div class="product-quantity" >
                                                                <div>
                                                                    <!-- just kept blank -->
                                                                </div>
                                                                <NewQuantityBox
                                                                    :minimum_unit="1"
                                                                    v-model="items.qty"
                                                                    :quantity="
                                                                        items.qty
                                                                    "
                                                                    @changed="
                                                                        update_cart()
                                                                    "
                                                                    :immediate="false"
                                                                ></NewQuantityBox>
                                                            </div>
                                                        </div>

                                                        <div class="spec-right text-end mt-1">
                                                            <!-- NOTE: commented as per task requirments -->
                                                            <!-- <button
                                                                type="button"
                                                                class="btn  btn-icon"
                                                                :class="
                                                                    items.favorite !==
                                                                    null
                                                                        ? 'btn-danger'
                                                                        : 'btn-primary'
                                                                "
                                                            >
                                                                <img
                                                                    src="assets/images/heart.svg"
                                                                    @click.prevent="fev_popup(items)"
                                                                    alt=""
                                                                />
                                                            </button> -->

                                                            <button
                                                                type="button"
                                                                class="btn btn-danger btn-icon removeBtn"
                                                                @click.prevent="
                                                                    remove_cart(
                                                                        items.id,
                                                                        items.project_id,null
                                                                    )
                                                                "
                                                            >
                                                                <img
                                                                    src="assets/images/delete.svg"
                                                                    alt=""
                                                                />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div  class="col-md-12 col-lg-8"  v-else>

                            <div class="card product-cart-card text-center">
                                <h5>Your cart is empty!</h5>
                            </div>

                        </div>
                        <div class="col-md-12 col-lg-4">
                            <div class="card order-card">
                                <div class="card-body">
                                    <h5 class="border-bottom-1 pb-2">
                                        Order Detail
                                    </h5>
                                    <div class="d-flex align-items-center mb-2">
                                        <div
                                            class="flex-fill d-flex justify-content-between"
                                        >
                                            <div class="flex-fill">
                                                <label>Subtotal</label>
                                            </div>
                                            <div
                                                class="d-flex align-items-start flex-shrink-0"
                                            >
                                                <span class="font-600" v-if="projectCart">{{
                                                        projectCart.sub_total
                                                            | toCurrency
                                                    }}</span>
                                                     <span class="font-600" v-if="total">{{
                                                        total
                                                            | toCurrency
                                                    }}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="d-flex align-items-center mb-2">
                                        <div
                                            class="flex-fill d-flex justify-content-between"
                                        >
                                            <div class="flex-fill">
                                                <label>Shipping</label>
                                            </div>
                                            <div
                                                class="d-flex align-items-start flex-shrink-0"
                                            >
                                                 
                                                <span class="font-600" >--</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="d-flex align-items-center mb-2">
                                        <div
                                            class="flex-fill d-flex justify-content-between"
                                        >
                                            <div class="flex-fill">
                                                <label>Tax</label>
                                            </div>
                                            <div
                                                class="d-flex align-items-start flex-shrink-0"
                                            >
                                                <span class="font-600">--</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        class="d-flex align-items-center border-top pt-2 mb-4"
                                    >
                                        <div
                                            class="flex-fill d-flex justify-content-between textGreen"
                                        >
                                            <div class="flex-fill">
                                                <h5 class="mb-0">Total</h5>
                                            </div>
                                            <div
                                                class="d-flex align-items-start flex-shrink-0"
                                            >
                                                <h5 class="mb-0" v-if="projectCart">
                                                    {{
                                                        projectCart.sub_total
                                                            | toCurrency
                                                    }}
                                                </h5>
                                                <h5 class="mb-0" v-if="total">
                                                    {{
                                                        total
                                                            | toCurrency
                                                    }}
                                                </h5>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="delivery-info">Estimated Delivery in 5-7 Business Days</div>
                                    <div class="d-flex flex-wrap">
                                        <router-link
                                            to="/checkout"
                                            type="button"
                                            class="btn btn-primary w-100 mb-2 proceedCheckout"
                                            v-if="(projectCart && projectCart.Project_tans.length)"

                                        >Proceed to Checkout
                                        </router-link>
                                        <router-link
                                            to="/"
                                            type="button"
                                            class="btn btn-dark w-100">Continue Shopping
                                        </router-link
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div
            class="modal fade"
            id="pop_fav"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="staticBackdropLabel">
                            Add Favorites
                        </h5>

                    </div>
                    <div class="modal-body">
<!--                        <button type="button"-->
<!--                                class="close"-->
<!--                                data-dismiss="modal"-->
<!--                                aria-label="Close"-->
<!--                        >-->
<!--                            <span aria-hidden="true">&times;</span>-->
<!--                        </button>-->
                        <button
                            type="button"
                            class="btn btn-primary w-100"
                            style="height: 45px; line-height:14px; margin-top: 15px;"
                            @click="add_to_favorites"
                        >
                            ADD TO MY FAVORITES
                        </button>

                        <div class="dropdown customDropDown">
                            <button
                                class="btn btn-default dropdown-toggle w-100"
                                type="button"
                                id="actionDrp"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                                style="min-width: 95px;"
                                data-auto-close="outside"
                            >
                                Add to List
                            </button>
                            <form
                                @submit.prevent="create_favorite"
                                class="dropdown-menu w-100"
                                aria-labelledby="actionDrp"
                            >
                                <label
                                    class="dropdown-item"
                                    type="button"
                                    v-for="(item, index) in favorites"
                                    :key="ran_inx() + index"
                                    :for="'bft' + index"
                                >
                                    <div class="form-check">
                                                                <span class="form-check-label">
                                                                    <input
                                                                        type="checkbox"
                                                                        class="form-check-input"
                                                                        name=""
                                                                        :id="'bft' + index"
                                                                        :value="item.id"
                                                                        v-model="fav_frm.favorites"
                                                                    />
                                                                    {{ item.name }}
                                                                </span>
                                    </div>
                                </label>
                                <div class="px-2">
                                    <input
                                        type="text"
                                        class="form-control border p-2"
                                        style="font-weight: 500;"
                                        v-model="create_fav"
                                        placeholder="CREATE A LIST"
                                    />
                                </div>
                                <p v-if="errors.name" class="errormsg">
                                    {{ errors.name[0] }}
                                </p>

                                <button
                                    type="button"
                                    class="btn btn-primary w-100"
                                    style="height: 45px; line-height:14px; margin-top: 15px;margin-bottom: auto;"
                                    @click="add_to_favorites"
                                    v-if="fav_frm.favorites &&fav_frm.favorites.length > 0 "
                                >
                                    ADD TO MY List
                                </button>
                            </form>
                        </div>


                    </div>
<!--                    <div class="modal-footer">-->
<!--                        <button-->
<!--                            type="button"-->
<!--                            class="btn btn-primary"-->
<!--                            @click.prevent="showRoom"-->
<!--                            :disabled="!show_search"-->
<!--                        >-->
<!--                            Next-->
<!--                        </button>-->
<!--                    </div>-->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import NewQuantityBox from "../Elements/NewQuantityBox.vue";
import { EventBus } from "../store/eventBus";

export default {
    components: {
        NewQuantityBox
    },
    data() {
        return {
            items: {
                qty: 0
            },
            favorites: "",
            fav_frm: {
                id: "",
                favorites: []
            },
            create_fav: "",
            cart_items: [],
            total:0,
            cart_id:null
        };
    },
    computed: {
        ...mapGetters(["errors"]),
        ...mapGetters("cart", ["projectCart"]),
        ...mapGetters("Common", ["ShowRoom"]),
        ...mapGetters({ 
            showroomId:'Common/MyItem', 
        })
    },
    methods: {
        ...mapActions("cart", [
            "getCartData",
            "removeCartRequest",
            "updateCartRequest"
        ]),

        async fev_popup(item) {

            this.fav_frm.id = item.product_sizes_id;//item.id;
            if (item.favorite) {
                this.fav_frm.action = "remove";
                this.add_to_favorites();
            } else {
                delete this.fav_frm.action;
                $("#pop_fav").modal("show");
            }


        },

        async update_cart() {
            let cartloader = this.$loading.show();
            // console.log("this.cart_items",this.cart_items);
            // if(this.cart_items) {
            //     localStorage.setItem("cart_item", JSON.stringify(this.cart_items));
            //     cartloader.hide();
            // }else{
                let payload={items: this.projectCart.Project_tans};
                if(localStorage.getItem('cart_id')){
                    payload.temp_project_id=localStorage.getItem('cart_id');
                }
            this.updateCartRequest(payload)
                .then(res => {
                    cartloader.hide();
                })
                .catch(err => {
                    cartloader.hide();
                });
            // }
        },

        calculate_cart_total(cart_price = 0) {
            let coupon_percent = 0;
            let discount_price = 0;
            if (
                this.applied_coupon &&
                this.applied_coupon.discount &&
                !isNaN(this.applied_coupon.discount)
            ) {
                coupon_percent = Number(this.applied_coupon.discount);
            }
            discount_price = Number((cart_price * coupon_percent) / 100);
            this.discount_amt = discount_price.toFixed(2);
            return Number(cart_price - discount_price).toFixed(2);
        },
        async remove_cart(id, project_id,index) {
            console.log(index);
            Swal.fire({
                title: "Are You Sure You Want To Remove This Item?",
                text: "Item Will Be Removed From Your Cart.",
                showCancelButton: true,
                confirmButtonColor: "#d33",
                cancelButtonColor: "#3085d6",
                confirmButtonText: "Yes, Remove It!"
            }).then(result => {
                if (result.value) {
                    if(index!=null){
                        // this.cart_items.splice(index, 1);
                        // localStorage.setItem("cart_item", JSON.stringify(this.cart_items));
                        // EventBus.$emit('cart-updated');
                        // console.log("removed index: " + index);

                    }else{
                        let data = {
                            id: id,
                            params: {
                                project: project_id,
                                temp_project_id: this.cart_id
                            }
                        };
                        this.removeCartRequest(data).then(res => {
                        });
                        EventBus.$emit('cart-updated');
                    }
                }
            });
        },

        async add_to_favorites() {
            console.log("here fevvvvvvvvvvvv");
            axios.post("api/visualization/add_to_favorite", this.fav_frm)
                .then(res => {
                    console.log("res: ",res);
                    // let arr = this.products.data;
                    // let pid = this.fav_frm.id;
                    // var index = arr.indexOf(
                    //     arr.filter(function (item) {
                    //         return item.id == pid;
                    //     })[0]
                    // );
                    //   this.products.data[index].favorite=res.data.data
                    this.fav_frm.id = "";
                    this.fav_frm.action = "";
                    this.fav_frm.favorites = [];
                    $("#pop_fav").modal("hide");
                    window.location.reload();
                })
                .catch(err => {
                });
        },

        async create_favorite() {
            if (this.create_fav) {
                let loader = this.$loading.show();
                axios
                    .post("api/favorite", {

                        name: this.create_fav
                    })
                    .then(res => {
                        this.create_fav = "";
                        this.favorites.push(res.data.data);
                        Toast.fire({
                            icon: "success",
                            title: res.data.message
                        });
                        loader.hide();
                    })
                    .catch(err => {
                        loader.hide();
                    });
            }
        }
    },

    created() {
        this.favorites = this.ShowRoom;
        this.cart_id = localStorage.getItem("cart_id");
        // let cart_itemsL=localStorage.getItem('cart_item');
        // // console.log("=====<>?", cart_itemsL);
        // if(cart_itemsL){
        //     cart_itemsL=JSON.parse(cart_itemsL);
        //     this.cart_items = cart_itemsL;
        //     console.log("=====<<<<",this.cart_items);

        //     this.cart_items.map(el=>{
        //         this.total+=el.final_price;
        //     })
        //     console.log(this.total);
        // }
        //


    }
};
</script>
